import { useContainerQuery } from '../../internal/hooks/container-queries';
/**
 * Calculates chart container width considering left labels.
 */
export function useChartContainerWidth() {
    var LEFT_LABELS_MARGIN = 16;
    var _a = useContainerQuery(function (rect) { return rect.width; }), leftLabelsWidth = _a[0], leftLabelsRef = _a[1];
    var _b = useContainerQuery(function (rect) { return rect.width; }), containerWidth = _b[0], containerRef = _b[1];
    var width = containerWidth ? containerWidth - (leftLabelsWidth || 0) - LEFT_LABELS_MARGIN : 500;
    return [width, { containerRef: containerRef, leftLabelsRef: leftLabelsRef }];
}
//# sourceMappingURL=use-chart-container-width.js.map